import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  background-color: inherit;\n  top: 25px;\n  appearance: none;\n  border: none;\n  padding: 2px; /* just to make the clickable area a bit bigger */\n  margin: 0;\n  ", ";\n  ", ";\n\n  &:hover {\n    cursor: pointer;\n  }\n\n  &:hover,\n  &:focus {\n    outline: none;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  width: calc(100% - 100px);\n  max-height: 80vh;\n  max-width: 420px;\n  padding: 50px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  will-change: transform;\n  transition: all 0.2s ease-out;\n  overflow: hidden;\n  @media screen and (max-width: ", "px) {\n    width: calc(100% - 70px);\n    margin: 0 auto;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import { AcornsIcon } from '@acorns/icons';
import styled from '../utils/styling/styled-components';
import { Card as BaseCard } from '../Card';
import { ScreenReaderOnly } from '../ScreenReaderOnly';
import { BaseModal } from './BaseModal';
export var CloseButtonPosition;

(function (CloseButtonPosition) {
  CloseButtonPosition["upperLeft"] = "upperLeft";
  CloseButtonPosition["upperRight"] = "upperRight";
})(CloseButtonPosition || (CloseButtonPosition = {}));

var Card = styled(BaseCard)(_templateObject(), function (props) {
  return props.theme.breakpoints.sm;
});
var CloseButton = styled.button(_templateObject2(), function (props) {
  return props.position === CloseButtonPosition.upperLeft && 'left: 25px';
}, function (props) {
  return props.position === CloseButtonPosition.upperRight && 'right: 25px';
}); // AKA CardModal

export var Modal = function Modal(_ref) {
  var accessibilityProperties = _ref.accessibilityProperties,
      children = _ref.children,
      className = _ref.className,
      closeButton = _ref.closeButton,
      _ref$hasOverlayBackgr = _ref.hasOverlayBackground,
      hasOverlayBackground = _ref$hasOverlayBackgr === void 0 ? true : _ref$hasOverlayBackgr,
      isOpen = _ref.isOpen,
      _ref$isTrapModal = _ref.isTrapModal,
      isTrapModal = _ref$isTrapModal === void 0 ? false : _ref$isTrapModal,
      onCloseComplete = _ref.onCloseComplete,
      onOpenComplete = _ref.onOpenComplete,
      onRequestClose = _ref.onRequestClose,
      rest = _objectWithoutProperties(_ref, ["accessibilityProperties", "children", "className", "closeButton", "hasOverlayBackground", "isOpen", "isTrapModal", "onCloseComplete", "onOpenComplete", "onRequestClose"]);

  return /*#__PURE__*/React.createElement(BaseModal, {
    accessibilityProperties: {
      labelledBy: accessibilityProperties === null || accessibilityProperties === void 0 ? void 0 : accessibilityProperties.labelledBy,
      describedBy: accessibilityProperties === null || accessibilityProperties === void 0 ? void 0 : accessibilityProperties.describedBy
    },
    hasOverlayBackground: hasOverlayBackground,
    isOpen: isOpen,
    isTrapModal: isTrapModal,
    onCloseComplete: onCloseComplete,
    onOpenComplete: onOpenComplete,
    onRequestClose: onRequestClose
  }, /*#__PURE__*/React.createElement(Card, _extends({
    className: className
  }, rest), closeButton && /*#__PURE__*/React.createElement(CloseButton, {
    className: "modal-close-button"
    /* useful for targeting in styled-components */
    ,
    position: closeButton.position,
    onClick: onRequestClose,
    type: "button"
  }, /*#__PURE__*/React.createElement(ScreenReaderOnly, null, "Close"), /*#__PURE__*/React.createElement(AcornsIcon, {
    icon: AcornsIcon.Icon.CloseXIcon,
    height: closeButton.size || 16,
    width: closeButton.size || 16
  })), children));
};